module.exports = __webpack_public_path__ + "static/img/call-pass-off.9e65adf2.png";